// extracted by mini-css-extract-plugin
export default {"User":"User_User__ZKOW6","Avatar":"User_Avatar__6lvgQ"};